export default __webpack_public_path__ + "14cd64976741b32d5f2d82041b0ef15c.png";